export default __webpack_public_path__ + "static/media/logo_zad.a31c5b9d.png";